import { useSelector } from "react-redux";
import ElementaryPage from "./elementary/ElementaryPage";
import IntermediatePage from "./intermediate/IntermediatePage";
import AdvancedPage from "./advanced/AdvancedPage";
import StepsBar from "../../widgets/StepsBar";
import { getContentHeight } from "../../../../../utils/textUtils";

// ⚠ 구문분석은 재구축 금지 — 내부 UI는 레포 원본 그대로.
// 변경은 이 파일에서 상단 스텝바(StepsBar)를 붙이는 것 하나뿐이다.
// (레벨 페이지의 height:getContentHeight()→"100%"는 껍데기 높이 보정용 필수 1줄)
const SyntaxAnalysisPage = ({ setCurrentStep, isPreview }) => {
  const { section } = useSelector((state) => state.assignment);

  let levelPage = <div></div>;
  if (section?.question.level === "elementary") {
    levelPage = (
      <ElementaryPage
        section={section}
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
      />
    );
  } else if (section?.question.level === "intermediate") {
    levelPage = (
      <IntermediatePage
        section={section}
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
      />
    );
  } else if (section?.question.level === "advanced") {
    levelPage = (
      <AdvancedPage
        section={section}
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
      />
    );
  }

  return (
    <div
      style={{
        height: getContentHeight(),
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#FFFFFF",
      }}
    >
      <StepsBar />
      <div style={{ flex: 1, minHeight: 0, overflow: "hidden" }}>{levelPage}</div>
    </div>
  );
};

export default SyntaxAnalysisPage;
